// @flow
import React, { type Node, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import EmptyWarn from 'app/common/layouts/EmptyWarn';
import RowLayout from 'app/common/layouts/RowLayout';


type Props = {
  children: ?Node,
}

const UndefinedDate = ({ children }: Props): Node => {
  const { t } = useTranslation('dnevnik');

  return (
    <Fragment>
      {children}
      <RowLayout>
        <EmptyWarn skipPadding>
          {t(
            'dnevnik_error_empty_periodisation',
            'Не задана периодичность класса. Обратитесь к классному руководителю'
          )}
        </EmptyWarn>
      </RowLayout>
    </Fragment>
  );
};

export default UndefinedDate;
